<template>
	<div class="login-view" :class="configStore.electronMode ? 'electron' : ''">
		<AuthBackground v-if="!configStore.electronMode" />
		<div class="content">
			<el-form class="form" :model="loginForm" status-icon :rules="rules" ref="loginForm"
				@keyup.enter.native="submitForm()" v-loading="loading" element-loading-text="正在登陆...">
				<div class="form-header">
					<h1 class="form-welcome">演示模式登录</h1>
					<p class="form-welcome-subtitle">登录您的账号，开启聊天之旅</p>
				</div>
				<div class="form-body">
					<el-form-item prop="terminal" v-show="false">
						<el-input type="terminal" v-model="loginForm.terminal"></el-input>
					</el-form-item>
					<el-form-item prop="userName">
						<el-input type="userName" v-model="loginForm.userName" :placeholder="loginNamePlaceholder"
							prefix-icon="el-icon-user"></el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input type="password" v-model="loginForm.password" placeholder="密码"
							prefix-icon="el-icon-lock"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="nav-tool-bar">
							<el-checkbox v-model="isAutoLogin">下次自动登录</el-checkbox>
						</div>
					</el-form-item>
					<el-button class="submit-btn" type="primary" @click="submitForm()">登录</el-button>
					<div class="demo-account">
						<div class="demo-account-title">快速体验账号</div>
						<div class="demo-account-text">
							<span class="demo-account-label">账号：</span>
							<span class="demo-account-value">TT01~TT09</span>
						</div>
						<div class="demo-account-text">
							<span class="demo-account-label">密码：</span>
							<span class="demo-account-value">Aa123123</span>
						</div>
					</div>
					<div class="repo-section">
						<div class="divider-wrapper">
							<div class="divider-line"></div>
							<span class="divider-text">欢迎关注我们的开源仓库</span>
							<div class="divider-line"></div>
						</div>
						<div class="repo-links">
							<a class="repo-link" href="https://gitee.com/bluexsx/box-im" target="_blank"
								rel="noopener noreferrer">
								<img class="repo-logo" src="https://cdn.simpleicons.org/gitee/C71D23" alt="gitee" />
							</a>
							<a class="repo-link" href="https://github.com/bluexsx/box-im" target="_blank"
								rel="noopener noreferrer">
								<img class="repo-logo" src="https://cdn.simpleicons.org/github/181717" alt="github" />
							</a>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<icp></icp>
	</div>
</template>

<script>
import Icp from '../components/common/Icp.vue'
import AuthBackground from '../components/common/AuthBackground.vue'

export default {
	name: "login-in-demo",
	components: {
		Icp,
		AuthBackground
	},
	data() {
		const checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		const checkPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			}
			callback();
		};
		return {
			loading: false,
			isAutoLogin: true,
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: ''
			},
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}]
			}
		};
	},
	methods: {
		submitForm() {
			this.$refs.loginForm.validate((valid) => {
				if (!valid) {
					return;
				}
				this.loading = true;
				this.$http({
					url: "/login",
					method: 'post',
					data: this.loginForm
				}).then((data) => {
					localStorage.setItem('isAutoLogin', this.isAutoLogin);
					localStorage.setItem('username', this.loginForm.userName);
					localStorage.setItem('password', this.loginForm.password);
					sessionStorage.setItem("accessToken", data.accessToken);
					sessionStorage.setItem("refreshToken", data.refreshToken);
					this.$message.success('登录成功');
					this.$router.push("/home/chat");
				}).finally(() => {
					this.loading = false
				})
			});
		},
		generateDemoUserName() {
			const index = Math.floor(Math.random() * 9) + 1;
			return `TT${String(index).padStart(2, '0')}`;
		}
	},
	mounted() {
		this.loginForm.userName = this.generateDemoUserName();
		this.loginForm.password = "Aa123123";
		this.configStore.loadConfig();
		window.electronAPI && window.electronAPI.sendEvent('resize', {
			width: 380 + 40,
			height: 460 + 60,
			maximizable: false
		})
	},
	computed: {
		loginNamePlaceholder() {
			let mode = this.configStore.registration.mode;
			let strText = '用户名';
			if (mode.includes("phone")) {
				strText += "/手机号码"
			}
			if (mode.includes("email")) {
				strText += "/邮箱"
			}
			return strText;
		}
	}
}
</script>

<style scoped lang="scss">
.login-view {
	position: relative;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	background: #fff;
	overflow: hidden;

	.content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		z-index: 1;
	}

	.form {
		width: 380px;
		height: 460px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 32px 36px;
		background: rgba(255, 255, 255, 0.88);
		backdrop-filter: blur(24px);
		-webkit-backdrop-filter: blur(24px);
		border-radius: 28px;
		border: 1px solid rgba(255, 255, 255, 0.95);
		box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.04);
		overflow: visible;
	}

	&.electron .form {
		border-radius: 0;
		box-shadow: none;
		border: none;
	}

	.form-header {
		flex-shrink: 0;
		text-align: left;
		margin-bottom: 10px;
	}

	.form-welcome {
		margin: 0 0 6px;
		font-size: 25px;
		font-weight: 700;
		letter-spacing: 0.5px;
		line-height: 1.3;
		color: var(--im-color-primary);
	}

	.form-welcome-subtitle {
		margin: 0;
		font-size: var(--im-font-size);
		color: var(--im-text-color-light);
		line-height: 1.5;
	}

	.form-body {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		min-height: 0;
	}

	.form-body ::v-deep .el-form-item {
		margin-bottom: 14px;

		.el-input__inner {
			height: 52px;
			border-radius: 50px;
			border: 1px solid rgba(0, 0, 0, 0.06);
			background: #fff;
			transition: border-color 0.2s ease, box-shadow 0.2s ease;
			padding-left: 48px;
			font-size: var(--im-font-size-large);

			&:focus {
				border-color: rgba(0, 0, 0, 0.1);
				box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.8);
			}

			&::placeholder {
				color: var(--im-text-color-lighter);
				font-size: var(--im-font-size);
			}
		}

		.el-input__prefix {
			left: 18px;
		}

		.el-input__prefix .el-input__icon {
			color: var(--im-color-primary-light-3);
			font-size: 18px;
		}

		.el-input__suffix {
			display: none;
		}
	}

	.nav-tool-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}

	::v-deep .nav-tool-bar .el-checkbox__label {
		color: var(--im-text-color-light);
		font-size: var(--im-font-size-small);
	}

	.submit-btn {
		width: 100%;
		height: 52px;
		margin-top: 8px;
		border-radius: 50px;
		border: none;
		color: #fff;
		font-size: var(--im-font-size-larger);
		font-weight: 600;
		letter-spacing: 2px;
		transition: transform 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			transform: translateY(-1px);
		}
	}

	.demo-account {
		margin-top: 10px;
		padding: 10px 12px;
		background: rgba(255, 255, 255, 0.75);
		border-radius: 10px;
		font-size: var(--im-font-size-small);
		line-height: 1.6;
	}

	.demo-account-title {
		color: var(--im-text-color);
		font-weight: 600;
		margin-bottom: 2px;
	}

	.demo-account-text {
		padding: 1px 0;
	}

	.demo-account-label {
		color: var(--im-text-color-light);
	}

	.demo-account-value {
		color: var(--im-text-color);
		font-weight: 500;
	}

	.repo-section {
		margin-top: 10px;
	}

	.divider-wrapper {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.divider-line {
		flex: 1;
		height: 1px;
		background: linear-gradient(90deg, transparent, rgba(64, 112, 244, 0.35), transparent);
	}

	.divider-text {
		margin: 0 10px;
		font-size: 12px;
		color: var(--im-text-color-light);
		white-space: nowrap;
	}

	.repo-links {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 20px;
	}

	.repo-link {
		display: inline-flex;
		align-items: center;
	}

	.repo-logo {
		width: 24px;
		height: 24px;
	}
}
</style>
